import {
  SmallText,
  SmallTextBoldUnderline,
  TextBodyBold,
} from '@front/components/data-display/typography/Typography'
import { VanillaButtonStyle } from '@front/shared/constants/styles/VanillaButtonStyle'
import { capitalizeFirst } from '@hublo/utils/string'
import { InfoOutlined } from '@mui/icons-material'
import { Stack, useTheme } from '@mui/material'
import { useTranslation, Trans } from 'react-i18next'

type PromptProps = {
  apply: () => void
  name: string
}

export default function SpontaneousPromptCard({ apply, name }: PromptProps) {
  const theme = useTheme()
  const { t: tCareer } = useTranslation([
    'network.career_website',
    'main.common',
  ])

  return (
    <>
      <Stack
        sx={{
          borderRadius: 2,
          padding: 2,
          gap: 2,
          flexDirection: 'row',
          backgroundColor: theme.palette.background.info,
          border: 'solid 1px',
          borderColor: theme.palette.border.info,
          alignItems: 'center',
          // justifyContent: "center",
        }}
      >
        <InfoOutlined
          sx={{ width: 24, height: 24, color: theme.palette.text.info }}
        />
        <Stack
          sx={{
            gap: { xs: 1, md: 0 },
            flexDirection: { md: 'row', xs: 'column' },
            flex: 1,
          }}
        >
          <Stack sx={{ flex: 1 }}>
            <TextBodyBold>
              {tCareer('public.spontaneous_application')}
            </TextBodyBold>
            <Stack>
              <SmallText>
                <Trans>
                  {tCareer(
                    'network.career_website:public.spontaneous_description',
                    { institution: name },
                  )}
                </Trans>
              </SmallText>
            </Stack>
          </Stack>
          <button
            style={{
              ...VanillaButtonStyle,
              backgroundColor: 'transparent',
            }}
            onClick={apply}
          >
            <SmallTextBoldUnderline>
              {capitalizeFirst(tCareer('main.common:apply'))}
            </SmallTextBoldUnderline>
          </button>
        </Stack>
      </Stack>
    </>
  )
}
